import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_RICH_PLACEMENT_MULTIANCHOR } from './api/query'
import { Data, Variables } from './api/types'
import { RichPlacementMultianchor, UseGetRichPlacementMultianchor } from './types'

export const useGetRichPlacementMultianchor = (): UseGetRichPlacementMultianchor => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading } = useQuery<Variables, Data, RichPlacementMultianchor>({
    options: {
      select: ({
        workspaceRichPlacementMultianchorConfiguration,
      }: Data): RichPlacementMultianchor => fromDTO(workspaceRichPlacementMultianchorConfiguration),
    },
    query: GET_RICH_PLACEMENT_MULTIANCHOR,
    variables: { workspaceId },
  })

  return { isLoading, multianchor: data }
}
